import {Item, ItemBsi} from "./modal.graph.newRecord";
import {ppkPassThreshold} from "../../../component/level.cmp";

interface PlanType {
    valuePlan?: number | null
    valueComment?: Item | null
    valueBsi?: ItemBsi[] | null
    valuePpk: string
    valueDepth: number
}

// признак план для картинки графика
export function plan(props: PlanType) {
    const ppk = parseInt(props.valuePpk)
    const comment = props.valueComment?.label
    const plan = props.valuePlan
    const bsi = props.valueBsi
    const depth = props.valueDepth
    const threshold = ppkPassThreshold(ppk)
    const bsiDepth = bsi?.[bsi.length - 1]?.depth

    // запланированные мероприятия
    if (plan && ((plan === 1) || (plan === 2) || (plan === 5))) {
        if (comment && comment !== 'ЛГПП' && comment !== 'ППК') {
            return 5
        }
        if (comment === 'ЛГПП') {
            return 2
        }

        if (comment === 'ППК' && bsiDepth && bsiDepth >= threshold) {
            return 2
        }

        if (bsi && ppk && bsiDepth) {
            if (bsiDepth < threshold) {
                return 5
            } else {
                return 2
            }
        } else {
            if (ppk && depth < threshold) {
                return 5
            } else {
                return 2
            }
        }
    } else {
        if (comment && comment !== 'ЛГПП' && comment !== 'ППК') {
            return 4
        }
        if (comment === 'ЛГПП') {
            return 3
        }
        if (comment === 'ППК' && bsiDepth && bsiDepth >= threshold) {
            return 3
        }
        if (bsi && ppk && bsiDepth) {
            if (bsiDepth < threshold) {
                return 4
            } else {
                return 3
            }
        } else {
            if (ppk && depth < threshold) {
                return 4
            } else {
                return 3
            }
        }
    }
}
